import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNoaaShip(props) {
  return (
    <NtCaseStudySectionContainer
      title={
        "NOAA Ship Bell M. Shimada: Delivering Mission-Critical Communications"
      }
      style={styles.container}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Client</NtCaseStudyTextBold>
        {"\n"}National Oceanic and Atmospheric Administration (NOAA){"\n"}
        Agency under the U.S. Department of Commerce{"\n\n"}
        <NtCaseStudyTextBold>Project Overview</NtCaseStudyTextBold>
        {"\n"}
        NOAA contracted NT Connect to complete a system groom of the Public
        Address (PA), General Alarm (GA), and Private Branch Exchange (PBX)
        communication systems onboard the NOAA Ship Bell M. Shimada. This effort
        ensured reliable shipboard communications for crew safety, operations,
        and mission execution.{"\n\n"}
        <NtCaseStudyTextBold>Objectives</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Modernize and optimize the ship’s PA/GA/PBX systems.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Provide hardware upgrades to support ship-wide communications.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Deliver hands-on training for NOAA technicians and crew to ensure system
        sustainability.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Scope of Work</NtCaseStudyTextBold>
        {"\n"}
        NT Connect provided all parts, labor, materials, and services necessary
        to complete the system groom, including{"\n\n"}
        <NtCaseStudyTextBold>
          Hardware & Software Provisioning
        </NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Supplied two security USB keys.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Supplied upgraded VoIP base stations.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          System Installation & Configuration
        </NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Installed new VoIP endpoints at the Pilot House aft station.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Added PA access to phones in the Mess Room and XO Stateroom.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Conducted a comprehensive groom of PA, GA, and PBX systems.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Support & Training</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Provided 40 hours of remote support.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Conducted a two-day onboard session at NOAA’s Marine Operations Center –
        Pacific (MOC-P) in Newport, Oregon.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Delivered training and hands-on Q&A sessions with the ship’s electronics
        technicians and crew.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Results</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Enhanced reliability and redundancy of shipboard communications.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Expanded PA functionality for improved safety and operational reach.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Upgraded PBX hardware to support mission-critical ship-to-ship and
        ship-to-shore communication.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Trained NOAA personnel for ongoing maintenance, reducing future
        dependency on external support.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Impact</NtCaseStudyTextBold>
        {"\n"}
        By modernizing the PA/GA/PBX systems on the NOAA Ship Bell M. Shimada,
        NT Connect ensured:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Mission Readiness:</NtCaseStudyTextBold> The vessel
        is fully equipped to support NOAA’s research and operational missions.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Crew Safety:</NtCaseStudyTextBold> Reliable alarms
        and PA access across critical ship locations.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Operational Efficiency:</NtCaseStudyTextBold>{" "}
        Improved communication systems reduce downtime and streamline onboard
        coordination.
      </NtCaseStudyTextBullet>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNoaaShip;
